import { api } from './client';

export interface IngestInitResponse {
  mediaId: string;
  uploadUrl: string;
  r2Key: string;
  expiresInSeconds: number;
  tmdbMatched: boolean;
}

export async function ingestInit(body: {
  filename: string;
  contentType: string;
  sizeBytes: number;
  kind?: 'movie';
  title?: string;
  year?: number;
}) {
  return api.post<IngestInitResponse>('/api/ingest/init', { kind: 'movie', ...body });
}

export async function ingestFinalize(mediaId: string) {
  return api.post<{ mediaId: string; status: string; alreadyEnqueued?: boolean }>(
    '/api/ingest/finalize',
    { mediaId },
  );
}

/**
 * Upload a file to R2 via the presigned PUT URL. The Content-Type passed to
 * /ingest/init is baked into the signature, so we MUST send the same value.
 */
export async function uploadToR2(
  uploadUrl: string,
  file: File,
  onProgress?: (frac: number) => void,
) {
  return new Promise<void>((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('PUT', uploadUrl, true);
    xhr.setRequestHeader('Content-Type', file.type || 'application/octet-stream');
    if (onProgress) {
      xhr.upload.onprogress = (e) => {
        if (e.lengthComputable) onProgress(e.loaded / e.total);
      };
    }
    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) resolve();
      else reject(new Error(`R2 upload failed: HTTP ${xhr.status}`));
    };
    xhr.onerror = () => reject(new Error('R2 upload failed: network error'));
    xhr.send(file);
  });
}
